<template lang="pug">
div
  BriqPanel
    h2 Business Unit Billing Info
    .briq-form-element
      label Business Unit Name
      p {{ billing.BusinessUnitName }}    
    .briq-form-element
      label Business Unit Key
      p {{ billing.BusinessUnitKey }}    
    BriqMultiselect(
      name="SelectedBillingProductCode"
      label="Select Billing Product Code"
      help="Set the Billing Product Code"
      :options="availableProducts"
      track-by="Code"
      display="Name"
      v-model="billing.SelectedBillingProductCode"
      required="required"
      :error="selectedBillingProductError"
      )
  BriqPanel
    h2 General Contact Information
    div(v-if="billing.GeneralContactInformation")
      ContactInformationFields(
          :contactInformation="billing.GeneralContactInformation"
      )
    div(v-else)
      p No Contact Information
  BriqPanel(v-if="showFinancialContactDetails")
    h2 Financial Contact Information
    div(v-if="billing.FinancialContactInformation")
      ContactInformationFields(
          :contactInformation="billing.FinancialContactInformation"
      )
    div(v-else)
      p No Financial Contact Information
</template>

<script>
import { mapGetters } from 'vuex'
import ContactInformationFields from '@/vue/settings/application/billing/ContactInformationFields.vue'

export default {
  name: 'BillingSettingsFields',
  data() {
    return {
      // todo remove showFinancialContactDetails when we will have more information on Chargebee
      showFinancialContactDetails: false,
    }
  },
  components: {
      ContactInformationFields,
  },
  props: {      
    isSaving: Boolean,
    billing: Object,
    validations: Object,
  },
  computed: {
      ...mapGetters('businessUnitBillingData', [
          'selectedBillingProductCode',
          'generalContactInformation',
          'financialContactInformation',
          'availableProducts',
      ]),      
      selectedBillingProductError() {
        const error =
          this.validations?.$dirty &&
          this.validations.billing.SelectedBillingProductCode.$invalid &&
          'Billing Product Code is required'
        return error || null
    },
  },
}
</script>
